import { List, Create, Edit, View } from "../Components/index.js";

export default [
    {
        path: "/fd/sms",
        component: () => import("@/App/FD/SMS/Components/List.vue"),
        name: "sms-list",
        meta: {
            requiresAuth: true,
        },
    },
    // {
    //     path: "/fd/weekly-menu/:id/edit",
    //     component: Edit,
    //     name: "weekly-menu-edit",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
    // {
    //     path: "/fd/weekly-menu/:id/view",
    //     component: View,
    //     name: "weekly-menu-view",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
    // {
    //     path: "/fd/weekly-menu/create",
    //     component: Create,
    //     name: "weekly-menu-create",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
];
